import { $isLinkNode, LinkNode } from '@lexical/link';
import { $isTextNode, LexicalEditor } from 'lexical';

/**
 * Makes internal links behave as a single unit: their text runs in "token"
 * mode, so one backspace removes the whole link instead of shaving
 * characters off a still-linked, resolved title. Runs as a node transform so
 * it covers every source — the "#" picker, the toolbar, pasted URLs and
 * markdown re-import — without each having to opt in. External links keep
 * normal, character-editable text.
 */
export function registerInternalLinkAtomicDeletion(
  editor: LexicalEditor,
  isInternal: (url: string) => boolean
): () => void {
  return editor.registerNodeTransform(LinkNode, node => {
    if (!$isLinkNode(node)) return;

    const wantsToken = isInternal(node.getURL());

    node.getChildren().forEach(child => {
      if (!$isTextNode(child)) return;

      const isToken = child.getMode() === 'token';
      if (wantsToken && !isToken) {
        child.setMode('token');
      } else if (!wantsToken && isToken) {
        child.setMode('normal');
      }
    });
  });
}
